import GoogleMapsAutocomplete from "Constants/campaign/maps/googleMapsAutocomplete";
import AutocompleteFieldsOption from "JS/helpers/addressAutocomplete/fieldsOption";

// To reuse this mixin, add a `googleMapsAutocompleteMixin` object with your values for `addressInputID`, `addressVariableName`,
// and `zip5VariableName` to the component that is using this mixin; read the VueJS 2 documentation for more info:
// https://vuejs.org/v2/guide/mixins.html

export default {
  data: function() {
    return {
      // Object to store all overrideable variables; implement this in the component that is using this mixin
      googleMapsAutocompleteMixin: {
        addressInputID: GoogleMapsAutocomplete.DEFAULT_ADDRESS_SEARCH_ELEMENT, // The HTML ID of the address input element Autocomplete should be added to
        addressVariableName: GoogleMapsAutocomplete.DEFAULT_ADDRESS_VARIABLE_NAME, // The variable in the component that stores the user's address String
        zip5VariableName: GoogleMapsAutocomplete.DEFAULT_ZIP5_VARIABLE_NAME, // The variable in the component that stores the user's 5-digit ZIP code
      },
      autocomplete: false,
      addressData: {
        streetNum: false,
        streetName: false,
        zip5: false,
        zip4: null,
        city: null,
        county: null,
        country: null,
        state: null,
        lat: null,
        lon: null,
      }
    }
  },
  methods: {
    handleAutocompleteResponse() {
      if (this.autocomplete) {
        let updatedPlace = this.autocomplete.getPlace();
        if (updatedPlace) {
          this.saveAddressComponents(updatedPlace);
          this.updateAddressInputs();
        }
      }
    },
    saveAddressComponents(updatedPlace) {
      let shortName = GoogleMapsAutocomplete.GOOGLE_MAPS_PLACE_SHORT_NAME;
      // Store address data values (street number, street name, ZIP code)
      updatedPlace.address_components.forEach(component => {
        let addressType = component.types[0];
        if (addressType === GoogleMapsAutocomplete.GOOGLE_MAPS_PLACE_TYPE_ZIP5) {
          this.addressData.zip5 = component[shortName];

          if (updatedPlace.geometry) {
            this.addressData.lat = updatedPlace.geometry.location.lat();
            this.addressData.lon = updatedPlace.geometry.location.lng();
          }
        } else if (addressType === GoogleMapsAutocomplete.GOOGLE_MAPS_PLACE_TYPE_ZIP4) {
          this.addressData.zip4 = component[shortName];
        } else if (addressType === GoogleMapsAutocomplete.GOOGLE_MAPS_PLACE_TYPE_COUNTY) {
          this.addressData.county = component[shortName] ? component[shortName].replace(' County', '') : '';
        } else if (addressType === GoogleMapsAutocomplete.GOOGLE_MAPS_PLACE_TYPE_COUNTRY) {
          this.addressData.country = component[shortName];
        } else if (addressType === GoogleMapsAutocomplete.GOOGLE_MAPS_PLACE_TYPE_CITY) {
          this.addressData.city = component[shortName];
        } else if (addressType === GoogleMapsAutocomplete.GOOGLE_MAPS_PLACE_TYPE_SUBCITY) {
          // Use sublocality as fallback if city is not already set
          if (!this.addressData.city) {
            this.addressData.city = component[shortName];
          }
        } else if (addressType === GoogleMapsAutocomplete.GOOGLE_MAPS_PLACE_TYPE_STATE) {
          this.addressData.state = component[shortName];
        } else if (addressType === GoogleMapsAutocomplete.GOOGLE_MAPS_PLACE_TYPE_STREET_NUM) {
          this.addressData.streetNum = component[shortName];
        } else if (addressType === GoogleMapsAutocomplete.GOOGLE_MAPS_PLACE_TYPE_STREET_NAME) {
          this.addressData.streetName = component[shortName];
        }
      })
    },
    updateAddressInputs() {
      let { streetNum, streetName, zip5 } = this.addressData;
      if (streetNum  && streetName && zip5) {
        // Update addresss and ZIP code by using provided variable names
        this[this.googleMapsAutocompleteMixin.addressVariableName] = `${streetNum} ${streetName}`;
        this[this.googleMapsAutocompleteMixin.zip5VariableName] = zip5;
      }
    }
  },
  mounted: function() {
    this.autocomplete = new google.maps.places.Autocomplete(document.getElementById(this.googleMapsAutocompleteMixin.addressInputID), GoogleMapsAutocomplete.GOOGLE_MAPS_API_TYPES);
    this.autocomplete.setFields(
      new AutocompleteFieldsOption()
    );
    this.autocomplete.addListener('place_changed', this.handleAutocompleteResponse);
  }
}
